export default (cmedPrice = 0, estimated = 0) => {
  let lowerValue = 0
  if (estimated === 0 && cmedPrice > 0) {
    lowerValue = cmedPrice
  } else if (cmedPrice === 0 && estimated > 0) {
    lowerValue = estimated
  } else if (estimated < cmedPrice) {
    lowerValue = estimated
  } else if (cmedPrice < estimated) {
    lowerValue = cmedPrice
  }

  return lowerValue
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/define-lowest-max-price/index.js